export type Size = 'width' | 'height';

interface MaxElement {
  text: string;
  width: number;
}

/**
 *
 *
 * @param elementRefs - A list of elements that should be considered to find the maximum
 * @param sizeProperty - The size property to be used as compared value
 * @returns MaxElement containing information regarding the found element
 */
export function getElementWithMaxTextSize(
  elementRefs: Element[],
  sizeProperty: Size,
): MaxElement {
  if (elementRefs.length === 0) {
    return {
      text: '',
      width: 0,
    };
  }
  const maxLabelSize = elementRefs.reduce((prev, current) => {
    const prevSize = prev.getBoundingClientRect()[sizeProperty];
    const currentSize = current.getBoundingClientRect()[sizeProperty];

    return prevSize < currentSize ? current : prev;
  });

  return {
    text: maxLabelSize.textContent ?? '',
    width: Math.floor(maxLabelSize.getBoundingClientRect()[sizeProperty]),
  };
}
